// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1HAz9","label":"CategoryService_label__2pP_-","location":"CategoryService_location__nx-1k"};